import React__default from 'react';
import { b as TouchLinkContent, c as TouchLinkIcon } from './TouchLink.styles-D0GPtYUj.js';
import { b as angleInlineEnd } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';

const TouchLinkBody = ({
  children
}) => /*#__PURE__*/React__default.createElement(TouchLinkContent, null, children, /*#__PURE__*/React__default.createElement(TouchLinkIcon, {
  type: angleInlineEnd,
  size: "lg"
}));

export { TouchLinkBody as T };
//# sourceMappingURL=TouchLinkBody-D3Gm1YU4.js.map
